import React from 'react';
import { loadFile } from './quiz/helpers';
import { DropdownData } from './quiz/types';

export const AppContext = React.createContext<{
  data: unknown;
  setData: (value) => void;
  dropdownData: DropdownData;
  setDropdownData: (value) => void;
  loading?: boolean;
  loadFile: typeof loadFile;
  setLoading: (value: boolean) => void;
}>(null);
